import React, { Component } from 'react';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger';
  size?: 'sm' | 'md' | 'lg';
  as?: React.ElementType;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  as: Component = 'button',
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-[#FC4C02] text-white hover:bg-[#E04400] active:bg-[#C93D00]',
    secondary: 'bg-[#F7F7FA] text-[#2D2D2D] hover:bg-[#EDEDF0] active:bg-[#E0E0E5] border border-[#E8E8ED]',
    ghost: 'text-[#6B6B76] hover:text-[#2D2D2D] hover:bg-[#F7F7FA]',
    danger: 'bg-[#FEF2F2] text-[#E34402] hover:bg-[#FEE2E2] border border-[#FECACA]'
  };
  const sizes = {
    sm: 'h-9 px-4 text-sm rounded-full',
    md: 'h-11 px-6 text-sm rounded-full',
    lg: 'h-14 px-8 text-base rounded-full'
  };
  return <Component className={cn('inline-flex items-center justify-center font-semibold transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#FC4C02] focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50', variants[variant], sizes[size], className)} {...props} data-id="element-1178" />;
}